/**
 * userNames.js
 *
 * Pure display-name resolution for a stored user record (kept free of storage /
 * React imports so Jest can assert it directly).
 *
 * @module helpers/userNames
 */

/**
 * Best display name of a stored user record.
 *
 * Handles the shapes the backend / demo redaction produce: `{name: {first, last}}`,
 * a plain `name` string, `firstName` / `lastName`, then username / e-mail.
 *
 * @param {?object} user Stored user info.
 * @returns {{full: string, first: string}} Full and first name ('' when unknown).
 */
export const resolveUserNames = (user) => {
    if (!user || typeof user !== 'object') {
        return {full: '', first: ''};
    }

    let first = '';
    let last = '';

    if (user.name && typeof user.name === 'object') {
        first = String(user.name.first || '').trim();
        last = String(user.name.last || '').trim();
    } else if (typeof user.name === 'string' && user.name.trim()) {
        const parts = user.name.trim().split(/\s+/);

        [first] = parts;
        last = parts.slice(1).join(' ');
    } else {
        first = String(user.firstName || '').trim();
        last = String(user.lastName || '').trim();
    }

    if (!first && !last) {
        const fallback = String(user.username || user.userName || user.email || '').trim();

        return {full: fallback, first: fallback.split('@')[0]};
    }

    return {full: `${first} ${last}`.trim(), first: first || last};
};
